import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Grid } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
import ButtonCustom from 'src/shared/components/buttons/ButtonCustom'
import useSavePatient from '../hooks/useSavePatient'
import FormCompleteInformation from './components/FormCompleteInformation';

const IndexCompleteInformation = () => {
    const { handleClickCompleteInformation, loading } = useSavePatient();
    return (
        <div className='animate__animated animate__fadeIn'>
            <FormCompleteInformation />
            <Grid container display={"flex"} justifyContent={"flex-end"} p={2} pr={0}>
                <Box>
                    <ButtonCustom
                        color="secondary"
                        loading={loading}
                        text="CREE SU CONTRASEÑA"
                        icon={<NavigateNextIcon />}
                        onClick={handleClickCompleteInformation}
                    />
                </Box>

            </Grid>
        </div>
    )
}

export default IndexCompleteInformation;